import { BlocksIconArrowTriangularLeft } from 'blocks-nextjs/blocks-web-components/components/icon/icons/arrow-triangular-left';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconArrowTriangularLeft = createComponent({
  react: React,
  tagName: 'cat-icon-arrow-triangular-left',
  elementClass: BlocksIconArrowTriangularLeft
});
